import { put, takeLatest } from "redux-saga/effects";
import { actionTypes } from "Redux/services/actionTypes";
import apiCall from "Redux/services/apiCall";
import { API_REFUNDS } from "Redux/services/apiTypes";

export function* getRefundListWatcher() {
  yield takeLatest(actionTypes.GET_REFUND_LIST_METHOD, getRefundListWorker);
}

function* getRefundListWorker(action) {
  try {
    let url = {
      type: API_REFUNDS + action.payload.query,
      apiType: "GET",
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.GET_REFUND_LIST_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.GET_REFUND_LIST_FAIL, payload: error });
  }
}
